import type { ConnectHttpClient, ExternalUserKey } from '@ucc/common'
import { callApiWithStandardResponse, HttpVerb } from '@ucc/common'
import type {
  ChannelId,
  CreateSubscriptionsRequest,
  CreateSubscriptionsResponse,
  GetPresenceResponse,
  SubscriptionId,
  UserPresence,
} from './models'

export class PresenceService {
  private readonly endpoints = {
    presence: `${this.apiBaseUrl}/presence`,
    subscriptions: `${this.apiBaseUrl}/subscriptions`,
    subscriptionsById: (subscriptionId: string) => `${this.apiBaseUrl}/subscriptions/${subscriptionId}`,
    userPresence: `${this.apiBaseUrl}/user-presence`,
  }

  constructor(private readonly apiBaseUrl: string, private readonly httpClient: ConnectHttpClient) {}

  getUserPresence() {
    return callApiWithStandardResponse<UserPresence>(this.httpClient, HttpVerb.GET, this.endpoints.userPresence)
  }

  setUserPresence(userPresence: Partial<UserPresence>) {
    return callApiWithStandardResponse<UserPresence>(
      this.httpClient,
      HttpVerb.PATCH,
      this.endpoints.userPresence,
      userPresence,
    )
  }

  getPresence(externalUserKeys: readonly ExternalUserKey[]) {
    const params = new URLSearchParams()
    externalUserKeys.forEach(externalUserKey => params.append('externalUserKey', externalUserKey))

    return callApiWithStandardResponse<GetPresenceResponse>(
      this.httpClient,
      HttpVerb.GET,
      this.endpoints.presence,
      null,
      {
        params,
      },
    )
  }

  createSubscription(request: CreateSubscriptionsRequest) {
    return callApiWithStandardResponse<CreateSubscriptionsResponse>(
      this.httpClient,
      HttpVerb.POST,
      this.endpoints.subscriptions,
      request,
    )
  }

  deleteSubscriptionByChannelId(channelId: ChannelId) {
    return callApiWithStandardResponse<void>(this.httpClient, HttpVerb.DELETE, this.endpoints.subscriptions, null, {
      params: {
        channelId,
      },
    })
  }

  deleteSubscriptionBySubscriptionId(subscriptionId: SubscriptionId) {
    return callApiWithStandardResponse<void>(
      this.httpClient,
      HttpVerb.DELETE,
      this.endpoints.subscriptionsById(subscriptionId),
    )
  }
}
